import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { ChevronRightIcon } from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";
import TableContext from "context/table/tableContext";

import { SetContentProps, TABLE_VIEW_CONTENT } from "./types";

const InitialContent = ({ setContent }: SetContentProps) => {
    const { columns, hasNoPagination } = useContext(TableContext);

    const { t } = useTranslation();

    const atLeastOneColumnIsEnabled = columns.some(
        ({ isDisabled }) => !isDisabled
    );

    return (
        <>
            {columns.length > 0 && (
                <ListChoice
                    title={t("Button##select columns to show")}
                    iconRight={<ChevronRightIcon />}
                    disabled={!atLeastOneColumnIsEnabled}
                    onClick={() => setContent(TABLE_VIEW_CONTENT.Columns)}
                />
            )}

            {!hasNoPagination && (
                <ListChoice
                    title={t("Button##rows count per page")}
                    iconRight={<ChevronRightIcon />}
                    onClick={() => setContent(TABLE_VIEW_CONTENT.Rows)}
                />
            )}
        </>
    );
};

export default InitialContent;
